import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from '../components/Layout/Layout';
import { SEO } from '../components/Seo';
import { LinkProxy } from '../components/LinkProxy';

// eslint-disable-next-line no-unused-vars
const WithLayout = Component => {
  const wrapper = props => {
    const { content } = props.pageContext.node.data;
    return (
      <Layout content={content}>
        <SEO content={content} />
        <Component content={content} />
        <LinkProxy />
      </Layout>
    );
  };

  wrapper.propTypes = {
    pageContext: PropTypes.objectOf(PropTypes.any).isRequired
  };
  return wrapper;
};

WithLayout.propTypes = {
  Component: PropTypes.element
};

export default WithLayout;
